import { Stack } from '@mui/material'
import type { PropsWithChildren } from 'react'

type Props = PropsWithChildren
export const CardViewFooter = (props: Props) => {
  return (
    <Stack
      marginTop={1}
      direction="row"
      alignItems="baseline"
      justifyContent={'flex-end'}
      spacing={3}
      flexShrink={0}
    >
      {props.children}
    </Stack>
  )
}
